export default __webpack_public_path__ + "static/media/key.e990c852.svg";